import {combineReducers, configureStore} from '@reduxjs/toolkit'
import user from './slices/userSlice'

const reducer = combineReducers({
    user,
})
export default configureStore({
    reducer
})